

import React from 'react';
import Box from '@mui/material/Box';
import { reduxForm } from 'redux-form';

import api from '../../../../api/medAppApi';

import { useDispatch } from "react-redux";
import Button from '@mui/material/Button';
import LinearProgress from "@mui/material/LinearProgress";
import FormBuilder, { IMedAppFormField } from '../../../form';

import { Patient } from '../../../../models';
import { required, minLength, email } from '../../../form/utils/validations';
import { useQuery } from 'react-query';
import { createModel } from '../../store/actions';
import { putMessage } from '../../../app/store/actions';

const phoneCodes = ['+234', '+1', '+44'].map(v => ({ label: v, value: v }));

const PatientCreateForm: React.FC<any> = ({ mFields, name, handleSubmit, onSubmit }) => {

    const handleSubmitCallback = (value: any) => {
        onSubmit(value);
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitCallback)}>  <FormBuilder fields={mFields} name={name} />
            <Button type="submit" variant="contained">Continue</Button>
        </form>);
}

const PatientCreateReduxForm = reduxForm<any, any>({
    form: 'patient-create'
})(PatientCreateForm);


const PatientCreate: React.FC<{
    patient?: Patient
}> = ({ patient }) => {

    const dispatch = useDispatch();


    const {data: lgas, isFetching: isFecthing, isError } = useQuery('load-lgas', async () => {
     
        const ans2 = await api.lgas() as any as {code: number; data: {lgas: string[]}};
        return ans2.data.lgas.map(v => ({
            value: v,
            label: v
        }))
      }, );


    const fields: IMedAppFormField[] = React.useMemo(() => ([
        {
            name: 'Email',
            label: 'Email Address',
            type: 'email',
            validate: [email],

        },
        {
            name: 'FirstName',
            label: 'First Name',
            type: 'text',
            validate: [required, minLength(2)],

        },
        {
            name: 'LastName',
            label: 'Last Name',
            type: 'text',
            validate: [required, minLength(2)],

        },
        {
            name: 'phone',
            label: 'Phone Number',
            type: 'text',
            childFields: [
                {
                    variant: 'select',
                    inputExtras: phoneCodes,
                    name: 'countryCode',
                    defaultValue: '+234',
                    label: 'Country Code',
                    type: 'text'
                },

                {
                    name: 'phoneNumber',
                    placeholder: '0000-0000-0000-0000',
                    label: 'Phone Number',
                    validate: [required, minLength(10)],
                    type: 'text'
                }
            ]
        },

        {
            name: 'Password',
            label: 'Password',
            type: 'password',
            inputExtras: {
                disabled: !!patient
            },
            validate: !patient ? [required] : [],
        },

        {
            name: 'divider',
        
            type: 'text',
            variant: 'divider',
        },
        {
            name: 'Address',
            label: 'Adress',
            type: 'text',
            inputExtras: {
                multiline: true,
            },
            defaultValue: 'Eti-Osa',
            validate: [required, minLength(2)],

        },
        {
            variant: 'autocomplete',
            inputExtras: !!lgas ? lgas : [],
            name: 'LGA',
            label: 'LGA',
            validate: [required],
            type: 'text'
        },
        {
            name: 'BirthDate',
            label: 'Birth Date',
            type: 'text',
            variant: 'date-picker',
            validate: [required],
        },
 
        
    ]), [ patient, lgas]);

    React.useEffect(() => {
       if(isError) {
        dispatch(putMessage({type: 'error', message: 'Failed to load LGA data'}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isError])
    const handleSubmit = (value: any) => {
        const data = {...value};
        console.log(data);
        delete data.phone;
        delete data.location;
        if(!data.BirthDate) {
            return;
        }
        data.BirthDate = value.BirthDate.getTime();
        data.Status = 1;
        data.PhoneNumber = (value.phone.countryCode || '+234') + value.phone.phoneNumber
        data.Location = {"placeId":"null","location":"No Location Provided"};
    
        dispatch(createModel({
            model: data,
            modelName: 'patient',
        }))
    }

    
    return (
        <Box style={{
            width: '100%'
        }}>
            <Box sx={{
                width: '70%',
                maxWidth: '700px',
                minWidth: '250px',
                marginLeft: '1em'
            }}>
                {(isFecthing) && <LinearProgress />}
                <PatientCreateReduxForm mFields={fields} namel="kosy-2" onSubmit={handleSubmit} />
            </Box>
        </Box>
    )
};

export default PatientCreate;